export const isCustomDomain = (): boolean => {
  return (
    !window.location.hostname.includes('.decktopus.com') &&
    !window.location.host.includes('localhost')
  )
}
